(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["donaris-parcelamento"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Os valores são renderizados pelo servidor: ao trocar de variante o tema re-renderiza o bloco inteiro. */
    function fechar(fundo) {
      fundo.hidden = true;
      document.body.classList.remove('dpar-aberto');
      if (fundo.dparRaiz && fundo.dparRaiz.isConnected) fundo.dparRaiz.appendChild(fundo);
      else fundo.remove();
    }

    document.addEventListener('click', function (e) {
      var abrir = e.target.closest('[data-dpar-abrir]');
      if (abrir) {
        var raiz = abrir.closest('[data-dpar]');
        var fundo = raiz && raiz.querySelector('[data-dpar-fundo]');
        if (!fundo) return;
        fundo.dparRaiz = raiz;
        document.body.appendChild(fundo);
        document.body.classList.add('dpar-aberto');
        fundo.hidden = false;
        return;
      }

      var fundoAberto = e.target.closest('[data-dpar-fundo]');
      if (!fundoAberto) return;

      if (e.target.closest('[data-dpar-fechar]') || e.target === fundoAberto) {
        fechar(fundoAberto);
        return;
      }

      var aba = e.target.closest('[data-dpar-aba]');
      if (aba) {
        fundoAberto.querySelectorAll('[data-dpar-aba]').forEach(function (a) { a.setAttribute('aria-selected', String(a === aba)); });
        fundoAberto.querySelectorAll('[data-dpar-painel]').forEach(function (p) { p.hidden = p.dataset.dparPainel !== aba.dataset.dparAba; });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-dpar-fundo]:not([hidden])').forEach(fechar);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
